/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./typeDefinitions.vue?vue&type=template&id=1c06348a&scoped=true"
import script from "./typeDefinitions.vue?vue&type=script&lang=js"
export * from "./typeDefinitions.vue?vue&type=script&lang=js"
import style0 from "./typeDefinitions.vue?vue&type=style&index=0&id=1c06348a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06348a",
  null
  
)

export default component.exports